'use client';
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend } from 'chart.js';
import { ChartProps } from '@/types/chart';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

if (typeof window !== 'undefined')
  ChartJS.defaults.color = window.localStorage.getItem('theme') === 'dark' ? '#b0b0b0' : '#4d4d4d';

const backgroundColor = [
  'rgba(75, 192, 192, 0.2)',
  'rgba(153, 102, 255, 0.2)',
  'rgba(255, 159, 64, 0.2)',
  'rgba(255, 205, 86, 0.2)',
  'rgba(54, 162, 235, 0.2)',
];
const borderColor = [
  'rgba(75, 192, 192, 1)',
  'rgba(153, 102, 255, 1)',
  'rgba(255, 159, 64, 1)',
  'rgba(255, 205, 86, 1)',
  'rgba(54, 162, 235, 1)',
];

const BarChart = ({ chart }: { chart: ChartProps }) => {
  const { data, options, source } = chart;
  options.plugins.legend.display = true;

  data.datasets.forEach((dataset, i) => {
    dataset.backgroundColor = backgroundColor[i];
    dataset.borderColor = borderColor[i];
    dataset.borderWidth = 1;
    dataset.borderRadius = 5;
  });

  if (data.datasets.length === 1) {
    options.plugins.legend.display = false;
  }

  return (
    <>
      <Bar
        data={data}
        options={{
          ...options,
          scales: {
            x: {
              // For Chart.js version 4.x
              ticks: {
                autoSkip: false,

                maxRotation: 0,
                minRotation: 0,
                callback: function (value, index) {
                  // Ensure value is treated as a string and check if it needs to be split
                  let label = this.getLabelForValue(index);
                  if (label.length > 10) {
                    return label.substring(0, 9) + '...';
                  }
                  return label;
                },
              },
            },
          },
        }}
        className="max-w-full"
      />
      <p className="text-end w-full text-2xs mt-4">{source}</p>
    </>
  );
};

const PieChart = ({ chart }: { chart: ChartProps }) => {
  const { data, options, source } = chart;

  data.datasets.forEach((dataset, i) => {
    dataset.backgroundColor = backgroundColor.splice(0, dataset.data.length);
    dataset.borderColor = borderColor.splice(0, dataset.data.length);
  });

  return (
    <>
      <Pie data={data} options={options} />
      <p className="text-end w-full text-2xs mt-4">{source}</p>
    </>
  );
};

export { BarChart, PieChart };
